/**
 * TaskNode Constants
 */

// =============================================================================
// STATUS SYSTEM
// =============================================================================

/**
 * Fixed status categories - these are semantic and used by the system
 * for progress calculation, HUD features, dependency logic, etc.
 */
export const STATUS_CATEGORIES = {
  not_started: { id: 'not_started', label: 'Not Started', color: '#6b7280', order: 0 },
  in_progress: { id: 'in_progress', label: 'In Progress', color: '#3b82f6', order: 1 },
  blocked: { id: 'blocked', label: 'Blocked', color: '#ef4444', order: 2 },
  completed: { id: 'completed', label: 'Completed', color: '#22c55e', order: 3 },
};

/**
 * Category order for sorting statuses
 * not_started → in_progress → blocked → completed
 */
export const CATEGORY_ORDER = ['not_started', 'in_progress', 'blocked', 'completed'];

/**
 * Default statuses for new campaigns
 * Users can customize these per campaign
 */
export const DEFAULT_STATUSES = [
  { id: 'pending', name: 'To Do', category: 'not_started', color: '#6b7280', order: 0 },
  { id: 'in_progress', name: 'In Progress', category: 'in_progress', color: '#3b82f6', order: 1 },
  { id: 'completed', name: 'Done', category: 'completed', color: '#22c55e', order: 2 },
  { id: 'blocked', name: 'Blocked', category: 'blocked', color: '#ef4444', order: 3 },
];

/**
 * Legacy STATUS_CONFIG for backwards compatibility
 * Maps old status IDs to config objects
 * @deprecated Use getStatusConfig() with campaign.statuses instead
 */
export const STATUS_CONFIG = {
  pending: { label: 'To Do', color: '#6b7280', bg: 'rgba(107, 114, 128, 0.15)' },
  in_progress: { label: 'In Progress', color: '#3b82f6', bg: 'rgba(59, 130, 246, 0.15)' },
  completed: { label: 'Done', color: '#22c55e', bg: 'rgba(34, 197, 94, 0.15)' },
  blocked: { label: 'Blocked', color: '#ef4444', bg: 'rgba(239, 68, 68, 0.15)' },
};

/**
 * Node types supported in the flowchart
 */
export const NODE_TYPES = {
  task: {
    id: 'task',
    label: 'Mission',
    icon: '🎯',
    description: 'Standard mission node',
  },
  decision: {
    id: 'decision',
    label: 'Decision',
    icon: '🔀',
    description: 'Diamond-shaped decision point',
  },
  milestone: {
    id: 'milestone',
    label: 'Milestone',
    icon: '🚩',
    description: 'Named checkpoint in the flow',
  },
  note: {
    id: 'note',
    label: 'Note',
    icon: '💬',
    description: 'Comment attached to a mission',
  },
};

export const CATEGORY_COLORS = [
  '#3b82f6', // Blue
  '#8b5cf6', // Purple
  '#ec4899', // Pink
  '#f59e0b', // Amber
  '#10b981', // Emerald
  '#06b6d4', // Cyan
  '#ef4444', // Red
  '#84cc16', // Lime
  '#f97316', // Orange
  '#6366f1', // Indigo
];

